export default __webpack_public_path__ + "static/media/google-play.42b73df8.png";